import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

export const useDoctorForm = ({ open, editing, onOpenChange, onSaved, empty }) => {
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  useEffect(() => {
    if (open) setForm(editing ? { ...empty, ...editing, fee: String(editing.fee) } : empty);
  }, [open, editing, empty]);

  const submit = async () => {
    if (!form.name.trim()) return toast.error("Enter doctor name");
    if (!form.specialty.trim()) return toast.error("Enter specialty");
    setSaving(true);
    try {
      const payload = { ...form, fee: parseFloat(form.fee || 0), slot_minutes: parseInt(form.slot_minutes || 30, 10) };
      if (editing) await api.patch(`/doctors/${editing.id}`, payload);
      else await api.post("/doctors", payload);
      toast.success(editing ? "Doctor updated" : "Doctor added");
      onOpenChange(false);
      onSaved();
    } catch (err) {
      toast.error(apiError(err, "Could not save doctor"));
    } finally {
      setSaving(false);
    }
  };

  return { form, set, saving, submit };
};
